export const getAnalyticsDisabledTooltip = (cutoverDate: string | undefined) => {
  const parsedCutoverDate = cutoverDate ? new Date(cutoverDate) : null;

  if (!parsedCutoverDate || Number.isNaN(parsedCutoverDate.getTime())) {
    return "Analytics is unavailable for this date range.";
  }

  const formattedCutoverDate = parsedCutoverDate.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });

  return `Analytics is unavailable for date ranges before ${formattedCutoverDate}.`;
};
